import { render, staticRenderFns } from "./个税申缴.vue?vue&type=template&id=15a868e6&scoped=true&"
import script from "./个税申缴.vue?vue&type=script&lang=js&"
export * from "./个税申缴.vue?vue&type=script&lang=js&"
import style0 from "./个税申缴.vue?vue&type=style&index=0&id=15a868e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a868e6",
  null
  
)

export default component.exports